import Routes from "./routes/Routes";
import { SiteSettingsProvider } from "./contexts/SiteSettingsContext";

function App() {
    return (
        <SiteSettingsProvider>
            <Routes/>
        </SiteSettingsProvider>
    );
}

export default App;
